/* Exports all the actions from a single point.

 Allows to import actions like so:

 import {action1, action2} from '../actions/'
 */
/* Populated by react-webpack-redux:action */
import test from './test.js';
import generics from './generics.js';

const actions = {
	test,
	generics
};
module.exports = actions;



// WEBPACK FOOTER //
// ./actions/index.js